module.exports = __webpack_public_path__ + "img/music-test-icon5.694035af.png";